import React from "react";
import "components/InterviewerListItem.scss";
import classNames from "classnames";

export default function InterviewerListItem(props) {
  const clickInterviewer = classNames("interviewers__item", {
    "interviewers__item--selected": props.selected,
  });

  return (
    <li
      onClick={props.setInterviewer}
      className={clickInterviewer}
      data-testid="interviewer-list-item"
    >
      <img
        className="interviewers__item-image"
        src={props.avatar}
        alt={props.name}
      />
      {props.selected && props.name}
    </li>
  );
}
